function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useContext } from 'react';
import { StaticContext, clientErrorHandler } from '../../..';
var MAX_LEN = 90;
var useRecaptcha = function useRecaptcha(_ref) {
  var actionName = _ref.actionName,
    siteKey = _ref.siteKey,
    useEnterprise = _ref.useEnterprise,
    successCallback = _ref.successCallback,
    errorCallback = _ref.errorCallback;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    greToken = _useState2[0],
    setGreToken = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showError = _useState4[0],
    setShowError = _useState4[1];
  var _useContext = useContext(StaticContext),
    recaptchaV3 = _useContext.recaptchaV3;
  var instanceSiteKey = siteKey || recaptchaV3.siteKey;
  var instanceUseEnterprise = useEnterprise || recaptchaV3.useEnterprise;
  function greSuccessCallback(token) {
    setGreToken(token);
    if (successCallback) {
      successCallback(token);
    }
  }
  function greErrorCallback(err) {
    var reason = String(err);
    var shortReason = reason.substring(0, MAX_LEN);
    clientErrorHandler.logError("Unable to execute. R: ".concat(shortReason), 'gre.getToken.error');
    setShowError(true);
    if (errorCallback) {
      errorCallback(err);
    }
  }
  function executeGRE() {
    var captchaService = window.grecaptcha;
    if (instanceUseEnterprise) {
      captchaService = window.grecaptcha.enterprise;
    }
    captchaService.execute(instanceSiteKey, {
      action: actionName
    }).then(greSuccessCallback, greErrorCallback);
    return true;
  }
  function fireGRE() {
    if (!instanceSiteKey) {
      clientErrorHandler.logError('Missing site_key', 'gre.fire.noSiteKey');
      return false;
    }
    executeGRE(actionName);
    return true;
  }
  return {
    greToken: greToken,
    setGreToken: setGreToken,
    showError: showError,
    setShowError: setShowError,
    fireGRE: fireGRE
  };
};
export default useRecaptcha;
//# sourceMappingURL=useRecaptcha.js.map